import React from 'react';
import ContentControlDetailSection from '../../../sections/AdminDashboard/Configuration/ContentControlDetail';

const ContentControlDetail = () => <ContentControlDetailSection />;

export default ContentControlDetail;
